import React, { Component } from 'react';

class TextField extends Component<any, any> {
  constructor(props: any){
    super(props);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch(ev: React.ChangeEvent<HTMLInputElement>) {
    this.props.handleSearch(ev.target.value.toLowerCase());
  }

  render() {
    return (
      <span>
        {/* <blockquote className="blockquote">It's a life lesson they need to have, a subject everybody needs - to cook.</blockquote>
        <footer className="blockquote-footer">Guy Fieri</footer>
        <br />
        
        <h4>Search Subjects:</h4>
        <br />
        <br /> */}
        <input
          aria-label="Filter subjects"
          onChange={this.handleSearch}
          placeholder="Filter subjects"
          type="search"
          className="form-control"
        />
      </span>
    );
  }
}

export default TextField;
